"use client";

import { useEffect, useState } from "react";

export type DetectedOS = "mac" | "windows" | "other";

function detectOS(): DetectedOS {
  if (typeof navigator === "undefined") {
    return "other";
  }
  const ua = navigator.userAgent.toLowerCase();
  const platform = navigator.platform?.toLowerCase() ?? "";
  if (ua.includes("mac") || platform.includes("mac")) {
    return "mac";
  }
  if (ua.includes("win") || platform.includes("win")) {
    return "windows";
  }
  return "other";
}

/**
 * Resolves the visitor's OS after mount. Returns "other" during SSR and the
 * first client paint so hydration matches, then updates once mounted.
 */
export function useDetectedOS(): DetectedOS {
  const [os, setOs] = useState<DetectedOS>("other");
  useEffect(() => {
    setOs(detectOS());
  }, []);
  return os;
}

/** Smoothly scrolls the Setup section into view (used after a download starts). */
export function scrollToSetup() {
  if (typeof document === "undefined") {
    return;
  }
  document.getElementById("setup")?.scrollIntoView({ behavior: "smooth" });
}
